import { DropdownOption } from '../molecules/Dropdown';
import { RuleDrawerVariant } from './types';

export const conditionOptions: DropdownOption[] = [
  { value: 'substantiation', label: 'Substantiation status' },
  { value: 'case_status', label: 'Case status' },
  { value: 'case_category', label: 'Case category' },
  { value: 'RTC', label: 'Relationship to company' },
];

export const DRAWER_TITLES: Record<RuleDrawerVariant, string> = {
  [RuleDrawerVariant.NEW]: 'Add new rule',
  [RuleDrawerVariant.FALLBACK]: 'Add new fallback rule',
  [RuleDrawerVariant.EDIT]: 'Edit rule',
  [RuleDrawerVariant.EDITFALLBACK]: 'Edit fallback rule',
};

export const BUTTON_LABELS: Record<
  RuleDrawerVariant,
  { idle: string; creating: string }
> = {
  [RuleDrawerVariant.NEW]: { idle: 'Next', creating: 'Creating...' },
  [RuleDrawerVariant.FALLBACK]: { idle: 'Save', creating: 'Saving...' },
  [RuleDrawerVariant.EDIT]: { idle: 'Save', creating: 'Saving...' },
  [RuleDrawerVariant.EDITFALLBACK]: { idle: 'Save', creating: 'Saving...' },
};
